//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  name: 'AdvanceConfigAutoRepeat',
  computed: {
    ...mapGetters({
      enableSelectdAssigneers: 'workflow/getSelectdAssigneers',
    }),
  },
  props: {
    value: {
      type: Number,
      default: 1,
    },
    advanceSelectAssigners: {
      type: Array,
      default: () => [],
    },
    neighborSet: {
      type: Number,
      default: 1,
    },
    budgetSwitch: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    value(newval) {
      console.log(newval);
    },
  },
  methods: {
    advanceSelectAssignersChange(e) {
      this.$emit('updateAssigners', e);
    },
    neighborSetting(e) {
      this.$emit('neighborSetting', e);
    },
    budgetSwitchSetting(e) {
      this.$emit('budgetSwitchSetting', e);
    },
  },
};
